import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Close from '@mui/icons-material/Close';
import './AuditHistoryDialog.css';

const formatWhen = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
};

const AuditHistoryDialog = ({
  open,
  title,
  rows,
  loading,
  empty,
  onClose,
  t,
}) => (
  <Dialog
    open={!!open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    className="audit-history-dialog"
  >
    <DialogTitle className="audit-history-title">
      <span>
        {title ||
          (t && t('AuditHistory.Title', { defaultValue: 'Audit history' })) ||
          'Audit history'}
      </span>
      <IconButton aria-label="Close" onClick={onClose} size="small">
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {loading ? <LinearProgress /> : null}
      {!loading && !(rows && rows.length) ? (
        <p className="audit-history-empty">
          {empty ||
            (t &&
              t('AuditHistory.Empty', {
                defaultValue: 'No audit entries yet.',
              })) ||
            'No audit entries yet.'}
        </p>
      ) : null}
      {(rows || []).map((row) => (
        <article key={row.id} className="audit-history-row">
          <div className="audit-history-meta">
            <strong>{row.actor || '—'}</strong>
            <time>{formatWhen(row.created_on)}</time>
          </div>
          <p>{row.description}</p>
        </article>
      ))}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} sx={{ textTransform: 'none' }}>
        {(t && t('MessageControl.Close', { defaultValue: 'Close' })) || 'Close'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default AuditHistoryDialog;



// WEBPACK FOOTER //
// ./src/components/common/AuditHistoryDialog.js